import _extends from "@babel/runtime/helpers/extends";
import React, { createRef, useMemo } from 'react';
import classNames from 'classnames';
import { DropdownTheme, Dropdown as TPADropdown } from 'wix-ui-tpa/cssVars';
import { InputBorderStyle } from '../../../constants';
import { useConfig } from '../../../contexts/config-context';
import { useTranslation } from '../../../contexts/translation-context';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
import { getInputBorderStyle, useStyleParams } from '../../../contexts/style-params-context';
import { FIELD_ERROR_CLASS } from '../../../field-error';
import { getMonthList } from './helpers';
import { classes } from './month-select.st.css';
export function MonthSelect(props) {
  const {
    id,
    className,
    onChange,
    ...rest
  } = props;
  const {
    t
  } = useTranslation();
  const {
    isMobile,
    locale
  } = useConfig();
  const dropdown = /*#__PURE__*/createRef();
  const styleParams = useStyleParams();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const borderStyle = getInputBorderStyle(styleParams, isMobile);
  const options = useMemo(() => getMonthList(locale).map((month, index) => ({
    value: month,
    id: "" + (index + 1),
    isSelectable: true
  })), [locale]);
  return /*#__PURE__*/React.createElement(TPADropdown, _extends({}, rest, {
    key: String(Boolean(props.value)),
    upgrade: true,
    ref: dropdown,
    newErrorMessage: true,
    mobileNativeSelect: isMobile,
    "aria-label": t('field.date.placeholder.month'),
    options: options,
    onChange: handleChange,
    initialSelectedId: props.value ? props.value.toString() : undefined,
    className: classNames(className, classes.root, {
      [FIELD_ERROR_CLASS]: props.error,
      [classes.hover]: forcedHover,
      [classes.mobileDropdown]: isMobile,
      [classes.noBorder]: borderStyle === InputBorderStyle.None
    }),
    theme: borderStyle === InputBorderStyle.Bottom ? DropdownTheme.Line : DropdownTheme.Box
  }));
  function handleChange(option) {
    var _dropdown$current;
    onChange == null || onChange(option.id);
    // force focus to be within the "date field" so validation won't be triggered prematurely
    (_dropdown$current = dropdown.current) == null || _dropdown$current.focus();
  }
}
//# sourceMappingURL=month-select.js.map